import { log } from "@app/app/services/log";

import { HostApiMethodData } from "../../api/methods";
import { ApiAdapter } from "../types";

export class ValidationApiAdapter implements ApiAdapter {
    private wrapped: ApiAdapter;
    private apiDefinitions?: HostApiMethodData[];

    public constructor(wrapped: ApiAdapter) {
        this.wrapped = wrapped;
    }

    public setValue(key: string, value: any): void {
        this.wrapped.setValue(key, value);
    }

    public exposeApi(api: HostApiMethodData[]) {
        this.apiDefinitions = api;
        this.wrapped.exposeApi(api);
    }

    public sendEventToHost(event: string, data: unknown) {
        this.wrapped.sendEventToHost(event, data);
    }

    public registerMethodHandler(method: string, handler: (...args: unknown[]) => Promise<unknown>): void {
        const schema = this.apiDefinitions?.find((def) => def.methodName === method)?.functionSchema;
        if (!schema) {
            log.debug("[ValidationApiAdapter] No schema found for method, passing through", { method });
            this.wrapped.registerMethodHandler(method, handler);
            return;
        } else {
            const validatedMethod = schema.implementAsync(handler);
            this.wrapped.registerMethodHandler(method, (...args) =>
                validatedMethod(...args).catch((error) => {
                    log.error("[ValidationApiAdapter] Error calling method", { method, error });
                    return Promise.reject(new Error(`Error calling ${method}: ${error}`));
                })
            );
        }
    }
}
